import React from "react";
import { createRoot } from "react-dom/client";
import "@/styles/application.scss";
import App from "@/components/App";
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const el = document.getElementById("root");
if (el) createRoot(el).render(<App />);
